import { DatePicker } from 'antd';
import dayjs from 'dayjs';
import React from 'react';
import type { IngestionFilterCondition } from '../../types';

const { RangePicker } = DatePicker;

interface IngestionNoteDateRangePickerProps {
    condition: IngestionFilterCondition;
    groupId: string;
    updateCondition: (groupId: string, conditionId: string, updates: Partial<IngestionFilterCondition>) => void;
}

/**
 * Date range picker for note date filtering in ingestion filter
 */
export const IngestionNoteDateRangePicker: React.FC<IngestionNoteDateRangePickerProps> = ({
    condition,
    groupId,
    updateCondition,
}) => {
    const handleDateRangeChange = (dates: any) => {
        if (dates && dates[0] && dates[1]) {
            updateCondition(groupId, condition.id, {
                value: [dates[0].format('YYYY-MM-DD'), dates[1].format('YYYY-MM-DD')],
            });
        } else {
            updateCondition(groupId, condition.id, {
                value: undefined,
            });
        }
    };

    return (
        <RangePicker
            className="!h-[32px] w-full"
            onChange={handleDateRangeChange}
            value={
                condition.value && Array.isArray(condition.value) && condition.value.length === 2
                    ? [
                          condition.value[0] ? dayjs(String(condition.value[0])) : null,
                          condition.value[1] ? dayjs(String(condition.value[1])) : null,
                      ]
                    : null
            }
            format="MM-DD-YYYY"
            placeholder={['Start Date', 'End Date']}
        />
    );
};
